import classNames from 'classnames';
import DOMPurify from 'isomorphic-dompurify';
import { forwardRef } from 'react';

import s from './HtmlContent.module.scss';

interface HtmlContentProps {
  className?: string;
  content?: string | null;
  onClick?: () => void;
  allowedAttr?: string[];
  allowedTags?: string[];
  shouldIgnorePotentialXSS?: boolean;
}

const HtmlContent = forwardRef<HTMLDivElement, HtmlContentProps>(
  ({ content, className, onClick, allowedAttr, allowedTags, shouldIgnorePotentialXSS }, ref) => {
    if (!content) return null;

    const options: { ALLOWED_ATTR?: string[]; ALLOWED_TAGS?: string[] } = {};

    if (allowedAttr) {
      options.ALLOWED_ATTR = allowedAttr;
    }

    if (allowedTags) {
      options.ALLOWED_TAGS = allowedTags;
    }

    return (
      <div
        ref={ref}
        className={classNames(s.htmlContent, className)}
        dangerouslySetInnerHTML={{
          __html: shouldIgnorePotentialXSS ? content : DOMPurify.sanitize(content, options),
        }}
        onClick={onClick}
      />
    );
  },
);

HtmlContent.displayName = 'HtmlContent';

export default HtmlContent;
